import { WaiterHubEnum } from "../enums/waiter_hub.enum";
import { HubModel, OrderHubUrl, WaiterHubUrl } from "./api";

export const WaiterHubs = [
  {
    val: (companyId: string): HubModel => {
      return OrderHubUrl(companyId);
    },
    name: WaiterHubEnum.order,
  },
  {
    val: (companyId: string): HubModel => {
      return WaiterHubUrl(companyId);
    },
    name: WaiterHubEnum.waiterCall,
  },
];
